// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__UHOoZ","views":"FeedPhotosItem_views__JPlxD"};